export class GameConstants {

    public static VERSION = "1.5.3";
    public static DEVELOPMENT = false;
    public static SHOW_BOUNDING_AREAS = false; 

    public static TIME = 1200; // 1200
    
    public static GAME_WIDTH = 960;
    public static GAME_HEIGHT = 640;
    
    public static IZZYGAMES = "izzy games";
    public static MINIJUEGOS = "minijuegos";
    public static GAMEPIX = "gamepix";
    public static MARVEL_MEDIA = "Marvel Media";
    public static DICO = "dico4u";
    public static FUNO = "funo";
    public static YANDEX = "Yandex";
    public static SOLITAIRE_KOSTENLOS = "Solitaire Kostenlos";
    public static ELFINET = "Elfinet";
    public static DOCOMO = "Docomo";
    public static GAME_DISTRIBUTION = "GAME DISTRIBUTION";
    public static VIETTEL = "VIETTEL";
    public static POKI = "POKI";
    public static NONE = "sponsor";

    public static SPONSOR = GameConstants.POKI;
   
    public static LANGUAGE_FRENCH = "fr";
    public static LANGUAGE_ENGLISH = "en";
    
    public static CENTER_OUTER_CARDS_Y = 750;
    
    public static CARD_WIDTH = 75;
    public static CARD_HEIGHT = 105;
    
    public static HALF_CARD_WIDTH = 37.5;
    public static HALF_CARD_HEIGHT = 52.5;
    
    public static POINTS_CARD = 5;
    
    public static AUDIO_MUTED_KEY = "refuge-solitaire-audio-state";
    public static GAME_STATE_KEY = "refuge-solitaire-game-state";
    public static BEST_TIME_KEY = "refuge-solitaire-best-time";
}
